import { PageModsDisplay } from './PageModsDisplay';
import { ModBossLogDropdown } from './ModBossLogDropdown';

/**
 * A component that allows toggling of existing page UX mods as well as adding
 * new page level UX mods onto the page that are not configured in the site config service.
 * This is valuable for a mod developer who has configured a page mod in the UX mod config service
 * and wants to test what it looks like before having OM include it in a site config.
 */
export const DebugModPanel = () => {
  return (
    <>
      <ModBossLogDropdown />
      <PageModsDisplay />
    </>
  );
};
